


























import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { koutsuhiInputStore } from '@/store/form/KoutsuhiInputFormStore'
import KintaiLockTag from '@/components/kintai/molecules/KintaiLockTag.vue'
import KoutsuhiInputForm from '../organisms/KoutsuhiInputForm.vue'

@Component({
  components: { TcwLayoutBasicTemplate, KoutsuhiInputForm, KintaiLockTag }
})
export default class KoutsuhiInputPage extends Mixins(BasePage) {
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }
  protected get isLock(): boolean {
    return koutsuhiInputStore.isLock
  }
  protected save(): void {
    this.form.startSaveProc()
  }
}
